import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import flyTapPayTall from '../assets/products/fly-tap-pay-tall.png';

const CartPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page cartPage">
      <Header />
      <div className="page-header">Golf Course</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Beverage Cart</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Nothing pairs better with a 300-yard drive than an icy cold beverage. With IG Fly, our new all-in-one handheld POS, cart attendants can quickly take and fulfill golfers' orders followed by seamless fast payment to ensure they are back on the course in record time."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="IG Fly"
          imgSrc={flyTapPayTall}
          onClick={() => navigate('/solutions/ig-fly')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default CartPage;
